import React from "react";
import HomeScreen from "../Containers/Home/HomeScreen";

export const HomeRoute = (): React.JSX.Element => <HomeScreen />

